/*
*  this is for the w3s (not jQuery UI) tabs
 * The tab button and the tab content div must both have an attribute named "rwg-tab" with a value of GROUP-ID
 * The tab button and content div must have matching ids prefixed with 'tab-' and 'tabcontent-' respectively
 * For example:
 *  <div class="tabs">
 *    <button rwg-tab="srch-cemetery">Cemetery Search</button>
 *  </div>
 *  <div rwg-tab="srch-cemetery"></div>
 *
 * the initially active tab needs:  class="active"
 * the initially active tabcontent needs:  style="display: block"
 *
 * instantiation of this object will assign click handlers to all EXISTING elements with attribute "rwg-tab"
 * elements added to the DOM after instantiation will need to have a handler explicitly added e.g.
 *    onclick="rwg.tabClick(event)"
 */

export default function() {

  // initialization
  if (!rwg.config.fullDrawing) {
    document.querySelectorAll('[rwg-tab=side-draw]').forEach(node => node.remove())
  }
  if (rwg.config.hideSearch) {
    document.querySelectorAll('[rwg-tab=top-search]').forEach(node => node.remove())
  }

  /**
   *
   * @param {string} group_tab group and tab separated by hyphen
   * sets tab active, called by tabClick below,
   */
  function activate(group_tab) {
    let group = group_tab.split('-')[0];
    let tab = group_tab.split('-')[1];

    document.querySelectorAll('div[rwg-tab^=' + group + ']').forEach(function(div) {
      let thisone = div.getAttribute('rwg-tab').split('-')[1];
      thisone === tab ?
        div.style.display = 'block' :
        div.style.display = 'none';
    });

    document.querySelectorAll('button[rwg-tab^=' + group + ']').forEach(function(button) {
      let thisone = button.getAttribute('rwg-tab').split('-')[1];
      thisone === tab ?
        button.classList.add('active') :
        button.classList.remove('active');
    });

    // Stuff below should be listeners

    if (group === 'srch') {
      document.querySelector('#search_results').innerHTML = '';
    }

    if (group_tab === 'top-map') {
      // move the map back into #map-div back when switching back from print layout
      if (rwg.map.getTarget() !== 'map-div') {
        rwg.map.setTarget('map-div');
      }
      rwg.map.updateSize();
    }

    if (group_tab === 'top-print') {
      document.querySelector('#print-options').style.display = 'block';
      document.querySelector('#print-content').innerHTML = '';
      document.querySelector('#print-container').style.display = 'none';
    }
  }

  /**
   * Add a new tab to the end of an existing tab group
   * @param {object} opt including:
   *  group_tab: group and tab separated by hyphen, required
   *  button_text: the label for the tab button, required for all pratical purposes
   *  tab_innerHTML: the content for the body of the tab, optional, could add content later
   *  future options might allow passing a refrence to an existing element, fetching content from server, etc.
   *  future option could be the element to append div to, or prepend, or insertBefore
   *    which would allow the option of 'activate' which requires the div to be on the DOM
   *
   * 2023-09 instead of returning the new div, append it to the group
   * returns a div that contains the tab content
   */

  function add(opts) {
    let group = opts.group_tab.split('-')[0];
    let tab =   opts.group_tab.split('-')[1];

    // create the tab button
    let button = document.createElement('button');
    button.textContent = opts.button_text;
    button.setAttribute('rwg-tab', opts.group_tab);
    button.addEventListener('click', tabClick);
    // append the new button to the parentElement of this tab-button group
    document.querySelectorAll('button[rwg-tab^=' + group + ']')[0].parentElement.appendChild(button);

    // create the tab content div
    let div = document.createElement('div')
    div.setAttribute('rwg-tab', opts.group_tab)
    div.style.display = 'none'
    div.classList.add(opts.tab_classList)
    div.innerHTML = opts.tab_innerHTML
    // 2023-09 instead of returning the new div, append it to the group
    document.querySelectorAll('div[rwg-tab^=' + group + ']')[0].parentElement.appendChild(div);
    // would returning the div allow chaining? Like rwg.tabs.add(opts).id='my-tab'
    // return div;
  }

  function tabClick(evt) {
    const group_tab = evt.target.getAttribute('rwg-tab'); // string: "group-item"
    activate(group_tab);
    // evt.target.parentElement.classList.remove('responsive'); // ???
  }

  // attach click handler to each tab
  document.querySelectorAll('button[rwg-tab]').forEach(tab => {
    tab.addEventListener('click', tabClick)
  })

  /* // attach click handlers to hamburger menus
  document.querySelectorAll('button[rwg-menu]').forEach(function(menu) {
    menu.addEventListener('click', function() {
      menu.parentElement.classList.toggle('responsive'); // ???
    });
  });
  */

  return {
    activate: activate,
    add: add
  };

}
